import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { AnalyticsListener as AKAnalyticsListener } from '@atlaskit/analytics-next';
import PropTypes from 'prop-types';
import * as React from 'react';
import { EVENT_CHANNEL } from "../../../constants/analytics/events";
export default class AnalyticsListener extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onEvent", event => {
      const {
        children,
        ...attributes
      } = this.props;
      event.update(payload => ({ ...payload,
        attributes: { ...payload.attributes,
          ...attributes
        }
      }));
    });
  }

  render() {
    return /*#__PURE__*/React.createElement(AKAnalyticsListener, {
      channel: EVENT_CHANNEL,
      onEvent: this.onEvent
    }, this.props.children);
  }

}

_defineProperty(AnalyticsListener, "propTypes", {
  children: PropTypes.node.isRequired
});